const AVAILABLE_LOCALES=["en-gb","en-us","es-us","fr-ca","en-ca","pt-pt","en-ie","sv-se","nb-no","nl-nl","fi-fi","da-dk","de-ch","fr-ch","it-ch","en-au","de-de","fr-fr","de-at","nl-be","fr-be","es-es","it-it","en-nz","en-sg"];const isSpokeAvailable=(locale,developmentMode=false)=>developmentMode||AVAILABLE_LOCALES.includes(locale==null?void 0:locale.toLowerCase());

export { isSpokeAvailable };
//# sourceMappingURL=experiment.js.map
